import { teachers } from "@/mocks/homeData";

export default function TutorsSection() {
  return (
    <section id="tutors" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-amber-300 text-amber-700 text-xs font-semibold tracking-widest uppercase mb-4">
            Meet the Experts
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Learn from Ivy League Graduates
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Our tutors and counselors attended the world&apos;s top universities and know exactly what it takes to get in.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {teachers.map((teacher) => (
            <div
              key={teacher.id}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-amber-200 transition-all duration-300 group cursor-pointer"
            >
              {/* Photo */}
              <div className="relative w-full h-56 overflow-hidden bg-gray-100">
                <img
                  src={teacher.image}
                  alt={teacher.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-white/90 backdrop-blur-sm rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-xs font-bold text-gray-800">{teacher.rating}</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-0.5">{teacher.name}</h3>
                <p className="text-amber-600 text-xs font-semibold mb-2">{teacher.title}</p>
                <p className="text-gray-400 text-xs mb-4 leading-relaxed">{teacher.school}</p>

                <div className="flex items-center justify-between text-xs text-gray-500 border-t border-gray-100 pt-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-gray-400"></i> {teacher.experience}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line text-gray-400"></i> {teacher.students} students
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
